module.exports = __webpack_public_path__ + "media/topSection/top-section-2-f52a7e7f.png";